import { TranslationService } from "@/core/services/TranslationService";
import LocationDetail from "@/views/location/views/LocationDetail.vue";
import LocationSite from "@/views/location/views/LocationSite.vue";
import LocationDevice from "@/views/location/views/LocationDevice.vue";
import LocationActivity from "@/views/location/views/LocationActivity.vue";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
export function locationTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.location.locationName"),
      key: "name",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.createdBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function locationTableFilters() {
  return [
    {
      key: "filterLocationIds",
      label: TranslationService.translate("pages.location.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/LOCATION",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function lookupTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookups",
    entityLabel: TranslationService.translate("pages.lookup.title"),
  };
}

export const LOCATION_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKLocationCode",
  textKey: "text",
  valueKey: "value",
};

///////LocationSite////////
export function locationSiteTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.createdBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function locationSiteTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "siteForms",
    entityLabel: TranslationService.translate("common.forms"),
  };
}

export function locationDeviceTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.deviceName"),
      key: "deviceName",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.createdBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function locationDeviceTableFilters() {
  return [
    {
      key: "deviceIds",
      label: TranslationService.translate("common.devices"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/DEVICES",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function deviceLocationTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "locationDevices",
    entityLabel: TranslationService.translate("pages.location.title"),
  };
}

export function LocationActivityTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.dateTime"),
      key: "createdDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.user"),
      key: "createdBy",
      sortable: true,
    },
    // {
    //   name: TranslationService.translate("common.type"),
    //   key: "typeCodeText",
    //   sortable: false,
    // },
    {
      name: TranslationService.translate("common.event"),
      key: "descriptions",
      sortable: false,
      attrs: {
        class: "vz-dataTable-left",
      },
    },
  ];
}

export function LocationActivityTableFilters(): IDataTableFilterOption[] {
  return [
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "userIds",
      label: TranslationService.translate("pages.user.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    // {
    //   key: "type",
    //   label: TranslationService.translate("common.type"),
    //   type: "lookup",
    //   attrs: {
    //     mode: "tags",
    //   },
    //   url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKAuditType",
    //   textKey: "text",
    //   valueKey: "value",
    // },
  ];
}

export function locationRowTabs() {
  return [
    {
      title: TranslationService.translate("pages.location.locationDetail"),
      name: "location.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: LocationDetail,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("common.sites"),
      name: "location.site",
      icon: "bi bi-diagram-3 me-2 fs-4 text-primary",
      component: LocationSite,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("common.devices"),
      name: "location.device",
      icon: "bi bi-cpu me-2 fs-4 text-primary",
      component: LocationDevice,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("common.activity"),
      name: "location.activity",
      icon: "bi bi-signpost-2 me-2 fs-4 text-primary",
      component: LocationActivity,
      props: {
        data: {},
      },
    },
  ];
}
